export const RUN = 'RUN_JOYRIDE'
export const NEXT = 'NEXT_JOYRIDE'

const initialState = {
    run: false,
    stepIndex: 0
}

export default (state = initialState, action) => {
  switch (action.type) {
    case RUN:
      return Object.assign({}, state, {
        run: true,
        stepIndex: 0
      })
    case NEXT:
      return Object.assign({}, state, {
        stepIndex: state.stepIndex + 1
      })
    default:
      return state
  }
}

function run() {
  return {
    type: RUN
  }
}

function next() {
  return {
    type: NEXT
  }
}


// Logs the user out
export function runJoyride() {
  console.log('coucou joyride');
  return dispatch => {
    dispatch(run())
  }
}

export function nextJoyride() {
return dispatch => {
  dispatch(next())
}
}



// WEBPACK FOOTER //
// ./src/modules/joyride.js